import { CalendarDaily, SalesInfo, SettleInfo } from '@/types/statistics';

// 통계 리포트 탭 예시 데이터
export const salesInfoExample: SalesInfo = {
  TotalSalesAmount: 12055110,
  TotalSalesCount: 563,
  TotalSalesShippingFee: 304500,
  TotalSalesDiscountAmount: 10400,
};
export const settleInfoExample: SettleInfo = {
  TotalSettleAmount: 11918457,
  TotalSettleCompletionAmount: 11918457,
  TotalSettleYetAmount: 0,
};
export const calendarDailyListExample: Array<CalendarDaily> = [
  {
    Date: '2025-01-01T00:00:00',
    SalesAmount: 596890,
    SalesCount: 31,
    SalesDiscountAmount: 0,
    SalesShippingFee: 12000,
    SettleCompletionAmount: 0,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-02T00:00:00',
    SalesAmount: 595000,
    SalesCount: 28,
    SalesDiscountAmount: 0,
    SalesShippingFee: 18000,
    SettleCompletionAmount: 566293,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-03T00:00:00',
    SalesAmount: 367470,
    SalesCount: 17,
    SalesDiscountAmount: 0,
    SalesShippingFee: 12000,
    SettleCompletionAmount: 1145119,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-04T00:00:00',
    SalesAmount: 294000,
    SalesCount: 15,
    SalesDiscountAmount: 0,
    SalesShippingFee: 6000,
    SettleCompletionAmount: 0,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-05T00:00:00',
    SalesAmount: 639300,
    SalesCount: 32,
    SalesDiscountAmount: 0,
    SalesShippingFee: 15000,
    SettleCompletionAmount: 0,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-06T00:00:00',
    SalesAmount: 435200,
    SalesCount: 20,
    SalesDiscountAmount: 0,
    SalesShippingFee: 6000,
    SettleCompletionAmount: 759483,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-07T00:00:00',
    SalesAmount: 527570,
    SalesCount: 28,
    SalesDiscountAmount: 0,
    SalesShippingFee: 15000,
    SettleCompletionAmount: 852142,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-08T00:00:00',
    SalesAmount: 600120,
    SalesCount: 31,
    SalesDiscountAmount: 600,
    SalesShippingFee: 12000,
    SettleCompletionAmount: 550068,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-09T00:00:00',
    SalesAmount: 453300,
    SalesCount: 21,
    SalesDiscountAmount: 0,
    SalesShippingFee: 12000,
    SettleCompletionAmount: 607196,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-10T00:00:00',
    SalesAmount: 610820,
    SalesCount: 24,
    SalesDiscountAmount: 0,
    SalesShippingFee: 6000,
    SettleCompletionAmount: 311374,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-11T00:00:00',
    SalesAmount: 489100,
    SalesCount: 27,
    SalesDiscountAmount: 600,
    SalesShippingFee: 15000,
    SettleCompletionAmount: 0,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-12T00:00:00',
    SalesAmount: 581300,
    SalesCount: 24,
    SalesDiscountAmount: 600,
    SalesShippingFee: 9000,
    SettleCompletionAmount: 0,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-13T00:00:00',
    SalesAmount: 1013200,
    SalesCount: 45,
    SalesDiscountAmount: 0,
    SalesShippingFee: 17500,
    SettleCompletionAmount: 944187,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-14T00:00:00',
    SalesAmount: 603600,
    SalesCount: 27,
    SalesDiscountAmount: 0,
    SalesShippingFee: 12000,
    SettleCompletionAmount: 1534591,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-15T00:00:00',
    SalesAmount: 738900,
    SalesCount: 31,
    SalesDiscountAmount: 0,
    SalesShippingFee: 15000,
    SettleCompletionAmount: 716427,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-16T00:00:00',
    SalesAmount: 589760,
    SalesCount: 30,
    SalesDiscountAmount: 4400,
    SalesShippingFee: 26500,
    SettleCompletionAmount: 572882,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-17T00:00:00',
    SalesAmount: 382300,
    SalesCount: 16,
    SalesDiscountAmount: 600,
    SalesShippingFee: 18000,
    SettleCompletionAmount: 669667,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-18T00:00:00',
    SalesAmount: 439600,
    SalesCount: 23,
    SalesDiscountAmount: 0,
    SalesShippingFee: 6000,
    SettleCompletionAmount: 0,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-19T00:00:00',
    SalesAmount: 637320,
    SalesCount: 24,
    SalesDiscountAmount: 0,
    SalesShippingFee: 12000,
    SettleCompletionAmount: 0,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-20T00:00:00',
    SalesAmount: 789380,
    SalesCount: 37,
    SalesDiscountAmount: 3600,
    SalesShippingFee: 42000,
    SettleCompletionAmount: 868492,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-21T00:00:00',
    SalesAmount: 550800,
    SalesCount: 26,
    SalesDiscountAmount: 0,
    SalesShippingFee: 11500,
    SettleCompletionAmount: 1259800,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-22T00:00:00',
    SalesAmount: 120180,
    SalesCount: 6,
    SalesDiscountAmount: 0,
    SalesShippingFee: 6000,
    SettleCompletionAmount: 570437,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-23T00:00:00',
    SalesAmount: 0,
    SalesCount: 0,
    SalesDiscountAmount: 0,
    SalesShippingFee: 0,
    SettleCompletionAmount: 0,
    SettleYetAmount: -9701,
  },
  {
    Date: '2025-01-24T00:00:00Z',
    SalesAmount: 0,
    SalesCount: 0,
    SalesDiscountAmount: 0,
    SalesShippingFee: 0,
    SettleCompletionAmount: 0,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-25T00:00:00Z',
    SalesAmount: 0,
    SalesCount: 0,
    SalesDiscountAmount: 0,
    SalesShippingFee: 0,
    SettleCompletionAmount: 0,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-26T00:00:00Z',
    SalesAmount: 0,
    SalesCount: 0,
    SalesDiscountAmount: 0,
    SalesShippingFee: 0,
    SettleCompletionAmount: 0,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-27T00:00:00Z',
    SalesAmount: 0,
    SalesCount: 0,
    SalesDiscountAmount: 0,
    SalesShippingFee: 0,
    SettleCompletionAmount: 0,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-28T00:00:00Z',
    SalesAmount: 0,
    SalesCount: 0,
    SalesDiscountAmount: 0,
    SalesShippingFee: 0,
    SettleCompletionAmount: 0,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-29T00:00:00Z',
    SalesAmount: 0,
    SalesCount: 0,
    SalesDiscountAmount: 0,
    SalesShippingFee: 0,
    SettleCompletionAmount: 0,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-30T00:00:00Z',
    SalesAmount: 0,
    SalesCount: 0,
    SalesDiscountAmount: 0,
    SalesShippingFee: 0,
    SettleCompletionAmount: 0,
    SettleYetAmount: 0,
  },
  {
    Date: '2025-01-31T00:00:00Z',
    SalesAmount: 0,
    SalesCount: 0,
    SalesDiscountAmount: 0,
    SalesShippingFee: 0,
    SettleCompletionAmount: 0,
    SettleYetAmount: 0,
  },
];

// 통계 기간별 탭 예시 데이터
export const monthlySalesListExample = [
  {
    Month: '2024-07',
    FirstDayOfMonth: '2024-07-01T00:00:00',
    SalesAmount: 25475160,
    SalesAmountUntilDay: 25475160,
  },
  {
    Month: '2024-08',
    FirstDayOfMonth: '2024-08-01T00:00:00',
    SalesAmount: 22215990,
    SalesAmountUntilDay: 22215990,
  },
  {
    Month: '2024-09',
    FirstDayOfMonth: '2024-09-01T00:00:00',
    SalesAmount: 15904140,
    SalesAmountUntilDay: 15904140,
  },
  {
    Month: '2024-10',
    FirstDayOfMonth: '2024-10-01T00:00:00',
    SalesAmount: 18527260,
    SalesAmountUntilDay: 18527260,
  },
  {
    Month: '2024-11',
    FirstDayOfMonth: '2024-11-01T00:00:00',
    SalesAmount: 22732720,
    SalesAmountUntilDay: 22732720,
  },
  {
    Month: '2024-12',
    FirstDayOfMonth: '2024-12-01T00:00:00',
    SalesAmount: 19752370,
    SalesAmountUntilDay: 19752370,
  },
  {
    Month: '2025-01',
    FirstDayOfMonth: '2025-01-01T00:00:00',
    SalesAmount: 12272110,
    SalesAmountUntilDay: 12272110,
  },
];
export const activedMonthlySalesExample =
  monthlySalesListExample[monthlySalesListExample.length - 1];
export const activedMonthlySalesAmountExample = 3_644_040;
export const salesStoreListExample = [
  {
    MarketName: '스마트스토어',
    MarketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketSmartstore.png',
    StoreName: '셀러박스마켓',
    SalesAmount: 2_304_120,
    SalesPercentText: '63.2',
    SalesCount: 5550,
  },
  {
    MarketName: '아임웹',
    MarketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketImweb.png',
    StoreName: '헤이즐마켓',
    SalesAmount: 623_800,
    SalesPercentText: '17.1',
    SalesCount: 16,
  },
  {
    MarketName: '지그재그',
    MarketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketZigzag.png',
    StoreName: '제인마켓',
    SalesAmount: 395_980,
    SalesPercentText: '10.9',
    SalesCount: 6,
  },
  {
    MarketName: '롯데온',
    MarketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketLotteon.png',
    StoreName: '토니마켓',
    SalesAmount: 219_500,
    SalesPercentText: '6.1',
    SalesCount: 1,
  },
  {
    MarketName: '올웨이즈',
    MarketIconUrl:
      'https://cplat-images.s3.ap-northeast-2.amazonaws.com/sellerbox/market-icon/IconMarketAlwayz.png',
    StoreName: '제리마켓',
    SalesAmount: 100_640,
    SalesPercentText: '2.8',
    SalesCount: 10,
  },
];
